import React from 'react';
import { Button } from '@cargomatic/ui';
import { Download } from 'lucide-react';
import useSignedUrl from 'utils/hooks/useSignedUrl';
/**
 * Renders a download button for a Proof of Delivery document.
 * Returns null when no valid POD is available.
 */
export default function PODButton({ pod, podUrl, className = 'h-8 w-8', }) {
    const { fetchAndOpen, loading } = useSignedUrl();
    if (!pod || pod === 'Missing POD' || !podUrl)
        return null;
    return (React.createElement(Button, { variant: "ghost", size: "icon", "aria-label": "Download POD", className: className, disabled: loading, onClick: () => fetchAndOpen({ documentKey: pod }) },
        React.createElement(Download, { className: "h-4 w-4" })));
}
